import listStyle from "./list/list.module.scss";

interface Props {
  children: JSX.Element;
}

export function ActionButtonWrapper({ children }: Props) {
  return <div className={listStyle.additionalButtons}>{children}</div>;
}
